import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { GatsbyImage } from "gatsby-plugin-image";
import ArrowSvg from "../../images/arrow.svg";
import IconMedium from "../../images/icon-medium.svg";
import { combine, FADE_UP } from "../animationUtils";
import { slugify } from "../../utils/utils";

export const fragments = graphql`
  fragment MediumPost on PrismicMediumPost {
    uid
    type
    tags
    _previewable
    data {
      title {
        text
      }
      featured_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 460)
      }
      medium_link {
        url
      }
      team_member {
        document {
          ... on PrismicTeamMember {
            _previewable
            data {
              title {
                text
              }
              featured_image {
                alt
                gatsbyImageData(layout: CONSTRAINED, width: 100)
              }
              short_bio {
                text
              }
              position {
                text
              }
            }
          }
        }
      }
    }
  }
  fragment Homepage_Medium on PrismicHomepageDataBodyMedium {
    id
    items {
      medium_posts {
        document {
          ...MediumPost
        }
      }
    }
    primary {
      medium_title {
        text
      }
      show_featured_image_on_grid
    }
  }
  fragment FocusArea_Medium on PrismicFocusAreaDataBodyMediumPosts {
    id
    items {
      medium_posts {
        document {
          ...MediumPost
        }
      }
    }
    primary {
      medium_title {
        text
      }
      show_featured_image_on_grid
    }
  }
  fragment Page_Medium on PrismicPageDataBodyMediumPosts {
    id
    items {
      medium_posts {
        document {
          ...MediumPost
        }
      }
    }
    primary {
      medium_title {
        text
      }
      show_featured_image_on_grid
    }
  }
`;

const getAuthorData = (post) => {
  const authorImage = post?.document?.data?.author?.document?.data?.image;
  const authorName = post?.document?.data?.author?.document?.data?.name?.text;
  const authorPosition =
    post?.document?.data?.author?.document?.data?.position?.text;

  return {
    authorImage,
    authorName,
    authorPosition,
  };
};

const BlogPostItem = ({ delay, post, hideCat = false, showFeaturedImage }) => {
  const featured_image = post?.document?.data?.featured_image;
  const title = post?.document?.data?.title?.text;
  const author = getAuthorData(post);
  return (
    <motion.div
      {...combine(FADE_UP, {
        variants: {
          start: {
            transition: { delay },
          },
        },
      })}
      animate="start"
      className="blog-posts__col"
    >
      {showFeaturedImage && (
        <a href={post?.document?.url} className="blog-posts__image">
          {featured_image && (
            <GatsbyImage
              image={featured_image?.gatsbyImageData}
              alt={featured_image?.alt ? featured_image?.alt : title}
            />
          )}
        </a>
      )}
      <p className="blog-posts__category">
        {!hideCat && post?.document?.tags?.[0] !== undefined ? (
          <a href={`/blog/category/${slugify(post?.document?.tags?.[0])}/`}>
            {post?.document?.tags?.[0]}
          </a>
        ) : (
          ""
        )}
      </p>
      <a href={post.document.url} className="blog-posts__link-post">
        <h2 className="h9">{title}</h2>
        <div className="blog-posts__author">
          <div className="blog-posts__avatar">
            {author?.authorImage && (
              <GatsbyImage
                image={author?.authorImage?.gatsbyImageData}
                alt={
                  author?.authorImage?.alt
                    ? author?.authorImage?.alt
                    : author?.authorName
                }
              />
            )}
          </div>
          {author?.authorName && (
            <div>
              <span className="blog-posts__name">{author?.authorName}</span>
              {author?.authorPosition?.trim() && (
                <span className="blog-posts__position">
                  {author?.authorPosition}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="blog-posts__link">
          <IconMedium />
          <ArrowSvg />
        </div>
      </a>
    </motion.div>
  );
};

export default BlogPostItem;
